import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import SocketContainerWithReg from './SoceketIOContainer_WithReg';
import SocketContainerNoReg from './SocketContainerNoReg';
import { useWebcastSocket } from '../../context/WebcastSocket.jsx';

const SocketIOHOC = ({ isEventLive,onDemand, socket_wc,authorization, noRegID,eventID, children }) => {

  const [socketManager, setSocketManager] = useState(null);


  if (isEventLive) {
    console.log('SoceketIOContainer_WithReg', socket_wc)
    return (
      <SocketContainerWithReg onDemand={onDemand} socket_wc={socket_wc} isEventLive={isEventLive} authorization={authorization} noRegID={noRegID}>
        {children}
      </SocketContainerWithReg>
    );
  } else {
    return (
      <SocketContainerNoReg onDemand={onDemand} socket_wc={socket_wc} eventID={eventID} isEventLive={isEventLive}  noRegID={noRegID}>
      {children}
    </SocketContainerNoReg>
    );
  }
};

export default SocketIOHOC;
